
export const EXCHANGE_API_URL = 'https://api.thegraph.com/subgraphs/name/traderjoe-xyz/exchange';
export const BOOSTED_API_URL = 'https://api.thegraph.com/subgraphs/name/traderjoe-xyz/boosted-master-chef';
export const VEJOE_API_URL = 'https://api.thegraph.com/subgraphs/name/traderjoe-xyz/vejoe';
export const LATEST_BLOCK_API_URL = 'https://api.thegraph.com/index-node/graphql';

export const RPC_URL = 'https://api.avax.network/ext/bc/C/rpc';

export const ADDRESS_LABELS = {
    "0xe7462905b79370389e8180e300f58f63d35b725f": {label: "Yield Yak (yyJOE)", link: "https://yieldyak.com/yy/joe"},
    "0x1f2a8034f444dc55f963fb5925a9b6eb744eee2c": {label: "Beefy (beJOE)", link: "https://app.beefy.finance/#/avax/vault/beefy-beJoe"},
    // "0x5f6b945ed9e4a03ffdb5d675d12224045d7c7e76": {label: "North Pole (V1)", link: "https://northpole.money/#/vejoe"},
    "0xf30e775240d4137daea097109fea882c406d61cc": {label: "North Pole", link: "https://northpole.money/#/vejoe"},
    "0x0e25c07748f727d6cccd7d2711fd7bd13d13422d": {label: "Vector (zJOE)", link: "https://vectorfinance.io/#/stake"},
    "0x1ab6b2f60a7e8da9d521cf8f90b2a5b5d314b3a6": {label: "SteakHut (hJOE)", link: "https://www.steakhut.finance/protocol"},
}